let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kgQcx")).then(() => parcelRequire('gqAVe'));